import { useLingui } from '@lingui/react/macro'
import { notifications } from '@mantine/notifications'
import { trpc } from '../trpc'

export const invoiceHooks = {
  useGetInvoicePdf: (invoiceId: number | undefined) =>
    trpc.invoice.getInvoicePdf.useQuery(
      { invoiceId: invoiceId as number },
      {
        enabled: invoiceId !== undefined,
      },
    ),

  useGetInvoicePaymentUrl: () => {
    const { t } = useLingui()
    return trpc.invoice.getInvoicePaymentUrl.useMutation({
      onSuccess: (data) => {
        window.open(data.paymentUrl, '_blank')
      },
      onError: (error) => {
        notifications.show({
          title: t`Error`,
          message: error.message || t`Failed to open payment page`,
          color: 'red',
        })
      },
    })
  },
}
